let env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'localhost', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

if ( env === 'localhost' ) {
    env = 'qa';
}

export const currentEnv = env;

function getURL( url ) {
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const AUTH_ENDPOINT = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const LEARNING_RECORD_SERVICE_URL = getURL( 'https://(env.)api.biw.cloud/v1/learning-record' );
export const TRANSLATIONS_EDITOR_HATCH_URL = getURL( 'https://(env.)translations-editor-hatch.biw.cloud' );
export const WEB_EVENT_PROXY_URL = getURL( 'https://(env.)api.biw.cloud/v1/web-event-proxy' );
export const cmxService = getURL( 'https://(env.)api.biw.cloud/v2/cmx' );